interface TrackEvent {
  name: string;
  properties: any;
}

function track(nameSpace: string, name: string, properties: any): void {
  let eventType = `${nameSpace}.track`;
  const event = new CustomEvent<TrackEvent>(eventType, {
    detail: {
      name,
      properties,
    },
  });
  document.dispatchEvent(event);
}

export default {
  track,
};
